import * as z from 'zod';

export type BillingSimulationFormSchemaValues = z.infer<typeof billingSimulationFormSchema>;

export const billingSimulationFormSchema = z
    .object({
        start_date: z.string().nonempty(),
        end_date: z.string().nonempty(),
        discount_policy_ids: z.array(z.string()),
        voucher_type_ids: z.array(z.string()),
    })
    .refine((data) => new Date(data.start_date) <= new Date(data.end_date), {
        path: ['end_date'],
        message: 'End date must be on or after start date.',
    });
